import React from 'react';

import { Box, Button, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link, Route, Routes, useLocation } from 'react-router-dom';

import OhsModuleHeader from 'global-components/register/OhsModuleHeader';

import CategoryCusvalUITestMain from './form/cusval-category/CategoryCusvalUITestMain';
import FixedCusvalUITestMain from './form/cusval-fixed/FixedCusvalUITestMain';
import SysFieldCusvalGroupTestMain from './form/sys-field/SysFieldCusvalGroupTestMain';

const useStyles = makeStyles()((theme: Theme) => ({
  card: {
    boxShadow: theme.shadows[2],
    borderRadius: '5px',
    background: 'white',
  },
  container: {
    display: 'flex',
  },
  innerContainer: {
    boxShadow: theme.shadows[2],
    borderRadius: '5px',
    display: 'flex',
  },
}));

function UITestContainer() {
  const { classes } = useStyles();
  const location = useLocation();

  const ROUTES = [
    {
      id: 1,
      name: 'Form',
      path: 'form',
      routes: [
        {
          id: 1,
          name: 'Cusval (dynamic)',
          path: 'cusval-dynamic',
          component: <CategoryCusvalUITestMain />,
        },
        {
          id: 2,
          name: 'Cusval (fixed)',
          path: 'cusval-fixed',
          component: <FixedCusvalUITestMain />,
        },
        {
          id: 3,
          name: 'System Field Cusval',
          path: 'system-field-cusval-group',
          component: <SysFieldCusvalGroupTestMain />,
        },
      ],
    },
    {
      id: 2,
      name: 'Test',
      path: 'test',
      routes: [{ id: 1, name: 'test', path: 'test', component: <Box>Test</Box> }],
    },
  ];

  return (
    <Box p={2} m={2} className={classes.card}>
      <OhsModuleHeader title="UI Container" as="h3" />

      <Box className={classes.container}>
        {/* Main sidebar */}
        <Box width={200} pr={2}>
          {ROUTES.map((mainRoute) => {
            const isActive = location.pathname.replace('ui-test', '').includes(mainRoute.path);
            return (
              <Box mb={1}>
                <Button
                  key={mainRoute.id}
                  component={Link}
                  to={`/ui-test/${mainRoute.path}`}
                  variant={isActive ? 'contained' : 'outlined'}
                  fullWidth
                >
                  {mainRoute.name}
                </Button>
              </Box>
            );
          })}
        </Box>

        {/* Main content */}
        <Box width="100%">
          <Routes>
            {ROUTES.map((mainRoute) => (
              <Route
                key={mainRoute.id}
                path={`${mainRoute.path}/*`}
                element={
                  <Box width="100%" p={2} className={classes.innerContainer}>
                    {/* Sidebar */}
                    <Box width={250} pr={2}>
                      {mainRoute.routes.map((route) => {
                        const isActive = location.pathname
                          .replace(new RegExp(`ui-test|${mainRoute.path}`, 'g'), '')
                          .includes(route.path);
                        return (
                          <Box mb={1}>
                            <Button
                              key={route.id}
                              component={Link}
                              to={`/ui-test/${mainRoute.path}/${route.path}`}
                              variant={isActive ? 'contained' : 'outlined'}
                              fullWidth
                            >
                              {route.name}
                            </Button>
                          </Box>
                        );
                      })}
                    </Box>

                    {/* Content */}
                    <Box width="100%" className={classes.innerContainer}>
                      <Routes>
                        {mainRoute.routes.map((route) => (
                          <Route
                            key={route.id}
                            path={route.path}
                            element={
                              <Box width="100%" maxWidth="1200px" p={2}>
                                {route.component}
                              </Box>
                            }
                          />
                        ))}
                      </Routes>
                    </Box>
                  </Box>
                }
              />
            ))}
          </Routes>
        </Box>
      </Box>
    </Box>
  );
}

export default UITestContainer;
